import PropTypes from 'prop-types'
import React from 'react'
import Category from './Category'
import { FilterResultsShape } from '../prop_shapes/FilterResultsShape'

const Categories = ({ categoryIds, filterResults, showUnpublishedCategories, onCategoriesChange }) => {
  const handleCategoryClick = category => {
    let newCategoryIds
    if (categoryIds.toString().includes(category.id.toString())) {
      newCategoryIds = []
    } else {
      newCategoryIds = [category.id]
    }
    onCategoriesChange(newCategoryIds)
  }

  const isSelected = category => {
    return categoryIds
      .map(id => id.toString())
      .includes(category.id.toString())
  }

  const renderCategory = category => {
    if (showUnpublishedCategories || category.live) {
      return (
        <Category
          key={category.id}
          category={category}
          count={filterResults.active_category_ids[category.id] || 0}
          selected={isSelected(category)}
          onCategoryClick={handleCategoryClick}
        />
      )
    }
  }

  const renderSubcategories = category => {
    return (
      filterResults
        .all_categories
        .filter(c => c.level === 'level_2' && c.level_1_id === category.id)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(childCategory => renderCategory(childCategory))
    )
  }

  const renderCategories = () => {
    return (
      filterResults
        .all_categories
        .filter(c => c.level === 'level_1')
        .map(category => (
          <React.Fragment key={category.id}>
            {renderCategory(category)}
            {renderSubcategories(category)}
          </React.Fragment>
        ))
    )
  }

  return (
    <ul className='category-menu pointer-clickable margin-bottom-3 margin-left-0'>
      {renderCategories()}
    </ul>
  )
}

Categories.propTypes = {
  filterResults: FilterResultsShape,
  categoryIds: PropTypes.array.isRequired,
  onCategoriesChange: PropTypes.func.isRequired,
  showUnpublishedCategories: PropTypes.bool
}

Categories.defaultProps = {
  filterResults: {
    active_segment: {},
    active_designations: {},
    active_category_ids: {},
    all_categories: [],
    all_designations: [],
    commodity_code_families: [],
    commodity_code_family_count: {},
    commodity_code_segments: {},
    commodity_code_segment_count: {},
    designations_by_state: {},
    rating_counts: {}
  },
  showUnpublishedCategories: false
}

export default Categories
